
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2c3.854 0 7 3.146 7 7a7.027 7.027 0 01-3.094 5.813c.486.208.964.441 1.406.719A7.965 7.965 0 0122 14.001c4.406 0 8 3.594 8 8s-3.594 8-8 8-8-3.594-8-8c0-1.897.671-3.657 1.781-5.031A7.889 7.889 0 0012 16.001c-4.431 0-8 3.569-8 8H2c0-4.119 2.527-7.658 6.094-9.188A7.025 7.025 0 015 9c0-3.854 3.146-7 7-7zm0 2C9.227 4 7 6.227 7 9s2.227 5 5 5 5-2.227 5-5-2.227-5-5-5zm10 12c-3.326 0-6 2.674-6 6s2.674 6 6 6 6-2.674 6-6-2.674-6-6-6zm-2.281 2.281L22 20.562l2.281-2.281 1.438 1.438L23.438 22l2.281 2.281-1.438 1.438L22 23.438l-2.281 2.281-1.438-1.438L20.562 22l-2.281-2.281z"}})])
          )
        }
      }
    